var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('btn',{attrs:{"type":_vm.type,"icon":_vm.icon,"href":_vm.href,"title":_vm.title,"action":_vm.action,"postform":_vm.postform,"delform":_vm.delform,"formid":_vm.formid,"light":"","bar":""}})}
var staticRenderFns = []

export { render, staticRenderFns }